import styled from "styled-components";
import { Flex } from "../style";
import { sizes, utils } from "../variables";

export const ImageContainer = styled.div`
  width: 95%;
`;

export const BorderTest = styled.div`
  width: 240px;
  height: 240px;
`;

export const EmptyContainer = styled(Flex)`
  gap: ${sizes.xl};
  justify-content: center;
  align-items: center;
  width: calc(${utils.width.fullVW} - 2 * ${sizes.xl});
  height: ${utils.height.fullVH};
  padding: 0 ${sizes.xl};
  flex-direction: column;

  div.bordered {
    padding: ${sizes.xl2};
    border-radius: ${sizes.sm};
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
  }

  .logo {
    height: 128px;
  }

  .banner {
    height: 100%;
    margin-right: ${sizes.xs};
  }

  .mobile-banner {
    display: none;
  }

  @media screen and (max-width: 425px) {
    font-size: 10px;
    .banner {
      display: none;
    }

    .mobile-banner {
      display: unset;
      width: 100vw;
    }
    img {
      width: 25%;
    }
  }

  @media screen and (min-width: 426px) and (max-width: 768px) {
    font-size: 12px;
    img {
      width: 25%;
    }
    .banner {
      display: none;
    }

    .mobile-banner {
      display: unset;
      width: 100vw;
    }
  }

  @media screen and (min-width: 769px) and (max-width: 1024px) {
    font-size: 10px;

    .logo {
      height: 80px;
    }

    .banner {
      height: 60%;
    }
  }

  @media screen and (min-width: 1024px) and (max-width: 1440px) {
    font-size: 12px;

    .logo {
      height: 96px;
    }

    .banner {
      height: 80%;
    }
  }
`;

export const AboutFlex = styled(Flex)`
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  gap: ${sizes.sm};

  .middle-image {
    display: none;
  }
  .side-image {
    display: block;
  }

  span {
    text-align: ${({ reverse }) => reverse ? 'right' : 'left'} !important;
  }
  @media screen and (max-width: 768px) {
    flex-direction: ${({ reverse }) => reverse ? 'column-reverse' : 'column'};
    justify-content: center;
    align-items: center;
    font-size: 8px;
    gap: ${sizes.xl4};

    .feedback-column {
      gap: ${sizes.xl};
    }

    .middle-image {
      display: block;
    }
    .side-image {
      display: none;
    }

    img {
      width: 100%;
    }

    span {
      text-align: left !important;
    }
  }

  @media screen and (min-width: 769px) and (max-width: 1024px) {
    flex-direction: ${({ reverse }) => reverse ? 'column-reverse' : 'column'};
    justify-content: center;
    align-items: center;
    font-size: 12px;
    gap: ${sizes.xl4};

    img {
      width: 60%;
    }

    .middle-image {
      display: none;
    }

    span {
      text-align: left !important;
    }
  }
`

export const Section = styled(Flex)`
  margin: ${sizes.lg} 0 ${sizes.lg} 0;
  width: calc(${utils.width.full} - 64px);
  flex-direction: column;
  alignItems: flex-start;
  p: 0 32px;
  gap: ${sizes.lg};
  margin-top: ${({ mt }) => mt};
  margin-bottom: ${({ mb }) => mb};

  @media screen and (max-width: 425px) {
    font-size: 12px;
  }

  div.footer {
    height: 100%;
    width: 100%;
  }
`

export const Footer = styled(Flex)`
  position: relative;
  bottom: 0px;
  left: 0;
  padding: ${sizes.lg} 0;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgb(254,0,110);
  background: linear-gradient(90deg, rgba(254,0,110,1) 0%, rgba(36,94,243,1) 100%);
  color: white;
`;